/*
 * author: wxq
 * createdTime: 2019/04/11
 * */

/**
 * label                       string                 false               label文字
 * dateApi                     api
 * date                        [{key：'', value: ''}]
 * onChangeSelect              func                                       下拉框改变的回调
 * type                        string[search,arrow]   arrow               下拉需不需要下拉的箭头
 * selectItem                  [{key：'', value: ''}]
 * searchParams
 */
import React, { PureComponent } from 'react';
import { Select, Icon } from 'antd';
import { getData } from '@util';
const Option = Select.Option;
class CsxMultipleSelect extends PureComponent {
  constructor() {
    super();
    this.state = {
      menu: '', // 下拉菜单
    };
  }
  componentDidMount() {
    // const {
    //     dateApi,
    //     data
    // } = this.props
    // if (data) {
    //   let menuObj
    //   menuObj = this.getMenu(data)
    //   this.setState({
    //     ...menuObj
    //   })
    // } else {
    //   dateApi && this.getAsyncDate(dateApi)
    // }
  }
  getAsyncDate(dateApi) {
    const reqData = { api: dateApi };
    const { searchParams, searchData } = this.props;
    if (searchParams) {
      reqData.searchParams = searchParams;
    } else if (searchData) {
      reqData.data = searchData;
    }
    getData(reqData).then(res => {
      let result = [];
      if (res.result) {
        if (Array.isArray(res.result)) {
          result = res.result;
        } else {
          result = res.result.list || res.result.data;
        }
      } else if (res.data) {
        if (Array.isArray(res.data)) {
          result = res.data;
        } else {
          result = res.data.data || res.data.list;
        }
      }
      const menuObj = this.getMenu(result);
      this.setState({ ...menuObj });
    });
  }

  // 组合menu菜单
  getMenu(data) {
    const { selectItem } = this.props;
    //添加如果返回数据是数组没有对象的下拉列表时自动添加key和value
    if (selectItem.isKey == 'NONE') {
      const newData = [];
      data.map((item, index) => {
        newData.push({ key: item, value: item });
      });
      data = newData;
    }
    const menu = data.map((o, i) => (
      <Option key={o[selectItem.key]} value={o[selectItem.key]}>
        {Array.isArray(selectItem.valueKey)
          ? selectItem.valueKey.map((x, y) => o[x]).join('')
          : o[selectItem.valueKey]}
      </Option>
    ));
    return {
      menu,
    };
  }
  // 选中下拉框的回调
  onMenuItemClick(key) {
    // valueObj.value = valueObj.eventKey
    this.props.onChangeSelect({ value: key.toString(), children: key });
  }

  // 聚焦的回调
  handleFocus = () => {
    const { dateApi, data } = this.props;
    if (data) {
      const menuObj = this.getMenu(data);
      this.setState({
        ...menuObj,
      });
    } else {
      dateApi && this.getAsyncDate(dateApi);
    }
  };
  render() {
    const { label, type, selectItem, style, require, commomInputStyle, mode, disabled } =
      this.props;
    const { menu } = this.state;
    if (!selectItem.data) {
      selectItem.data = {};
    }
    return (
      <div className="commonInput" style={commomInputStyle}>
        {label ? <label className={require ? 'show_required' : ''}>{label}：</label> : null}
        <div className="box" ref={r => (this.node = r)}>
          {type ? (
            <div className="icon-box">
              <Icon type={type} />
            </div>
          ) : null}
          <Select
            showSearch
            style={style}
            disabled={disabled}
            mode={mode || 'tags'}
            allowClear={true}
            tokenSeparators={[',']}
            showArrow={type ? false : true}
            optionLabelProp={'value'}
            dropdownMatchSelectWidth={false}
            placeholder="请选择"
            value={selectItem && selectItem.data.children}
            optionFilterProp="children"
            onChange={key => {
              this.onMenuItemClick(key);
            }}
            onFocus={() => {
              const node = this.node.querySelector('.ant-select-selection--multiple');
              const node1 = this.node.firstChild;
              node.style.height = 'auto';
              node1.style.height = 'auto';
              this.handleFocus();
            }}
            onBlur={() => {
              const node = this.node.querySelector('.ant-select-selection--multiple');
              const node1 = this.node.firstChild;
              node.style.height = '32px';
              node1.style.height = '32px';
            }}
            // onFocus={handleFocus}
            // onBlur={handleBlur}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {menu ? menu : null}
          </Select>
        </div>
      </div>
    );
  }
}
export default CsxMultipleSelect;
